<template>
  <CountryPage country="togo" />
</template>